import mobile from "../../assets/images/mobile.png";
import ml from "../../assets/images/ml.png";
import blog from "../../assets/images/blog.png";

export const ProjectData = [
  {
    id: 1,
    image: mobile,
    title: "Xplore-NU",
    category: "Mobile",
    link: "https://github.com/Ruthvikbr/Xplore-NU",
  },
  {
    id: 2,
    image: mobile,
    title: "Starbucks India Compose",
    category: "Mobile",
    link: "https://github.com/Ruthvikbr/Starbucks-India-Compose",
  },
  {
    id: 3,
    image: mobile,
    title: "Notes app with Ktor backend",
    category: "Mobile",
    link: "https://github.com/Ruthvikbr/Android/tree/master/Ktor-Notes-App",
  },
  {
    id: 4,
    image: ml,
    title: "American Sign Language Converter",
    category: "Machine Learning",
    link: "https://github.com/Ruthvikbr/ASL",
  },
  {
    id: 5,
    image: blog,
    title: "Automating Android App deployment with Play Developer APIs",
    category: "Blog",
    //link: "https://mature-beard-511.notion.site/Modern-Android-Development-33b8483ad23640d38d2566dc8f93a6ce",
    link: "https://medium.com/@Ruthvik_B.R/automating-android-app-deployment-with-play-developer-apis-717a8316f667",
  },
  {
    id: 6,
    image: blog,
    title: "Eatsy UX Case study",
    category: "UX/UI",
    link: "https://ruthvik-ravi.notion.site/UX-UI-Case-Study-0ed0152975384dc5ab4fab5c5d18ef7c",
  },
];

export const projectsNav = [
  {
    name: "All",
  },
  {
    name: "Mobile",
  },
  {
    name: "Machine Learning",
  },
  {
    name: "Blog",
  },
  {
    name:"UX/UI"
  }
];
